
import { useState } from 'react';

interface Room {
  id: string;
  name: string;
  subtitle: string;
  price: number;
  beds: string[];
  capacity: number;
  size: string;
  features: string[];
  images: string[];
  description: string;
}

const rooms: Room[] = [
  {
    id: 'classic-double',
    name: '經典美式雙人房',
    subtitle: '菊軒 | 菊韻復古，Stylish & Comfy',
    price: 1400,
    beds: ['大雙人床 x 1'],
    capacity: 2,
    size: '13 平方公尺',
    features: ['空調', '熱水壺', '寢具用品', '遮光窗簾'],
    images: ['https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/QzxbRfZIEc0SnbsRzngMhRumI7AxQWXtDSFKWz7d.jpeg'],
    description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
  },
  {
    id: 'family-six-eight',
    name: '熱鬧美日六-八人房',
    subtitle: '蘭軒|竹軒 | 蘭香竹影，Chill & Relax',
    price: 4200,
    beds: ['大雙人床 x 2', '雙人床 x 2'],
    capacity: 8,
    size: '25 平方公尺',
    features: ['空調', '雙人床', '上下舖', '超大雙人床'],
    images: ['https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/86H0M19ogedsVER8yqO1MOJODfbsEonKxIxaPUG2.jpeg'],
    description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
  },
  {
    id: 'cozy-four',
    name: '溫馨四人房',
    subtitle: '菊軒 | 菊色暖陽，Gather & Connect',
    price: 2400,
    beds: ['大雙人床 x 1', '雙人床 x 1'],
    capacity: 4,
    size: '13 平方公尺',
    features: ['空調', '遮光窗簾', '雙人床', '超大雙人床'],
    images: ['https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/d3v29cscst07uZKoYJKyMe9Yu9IyD2jky8OLQook.jpeg'],
    description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
  },
  {
    id: 'quiet-double',
    name: '恬靜雙人雅房',
    subtitle: '舒適寧靜的住宿空間',
    price: 1200,
    beds: ['大雙人床 x 1'],
    capacity: 2,
    size: '6 坪',
    features: ['空調', '延長線', '寢具用品', '遮光窗簾'],
    images: ['https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/u8a64YVr5zM2o4xymZmQggHyaDBoPp7h6YHpogsl.jpeg'],
    description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
  },
  {
    id: 'small-family',
    name: '小家庭套房',
    subtitle: '含廚房、客廳',
    price: 2100,
    beds: ['雙人床 x 1', '單人床 x 1'],
    capacity: 3,
    size: '15 坪',
    features: ['空調', '風扇', '書桌', '沙發'],
    images: ['https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/IKXjAItQ9ntcOJNGzJbhkeyHhHMPb7BV4H56hkyF.jpeg'],
    description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
  },
  {
    id: 'backpacker',
    name: '背包客房',
    subtitle: '隨心自在 心之所向',
    price: 500,
    beds: ['上下舖 x 1'],
    capacity: 1,
    size: '6 平方公尺',
    features: ['空調', '遮光窗簾', '上下舖', '共用浴室'],
    images: ['https://static.owlting.com/booking/image/h/e58601d0-6db2-459c-a50a-2573f839a561/images/i2gtViB4OZwt1ZgUVT1SJLzV3TBcsXS0q4aZMbOE.jpeg'],
    description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
  }
];

const packageDeal = {
  id: 'package-classic',
  name: '經典美式平房小屋包棟',
  subtitle: '八人房2間+四人房+一大廳(卡拉ok)+一廚房+戶外庭院烤肉空間',
  price: 10600,
  capacity: 20,
  size: '50 平方公尺',
  features: ['空調', '電熱水壺', '用餐區', '餐桌'],
  images: ['https://static.readdy.ai/image/5863ab0599d8617b625263a72ca2c390/b076a7ff27ea390c31c46b910289d5d6.jpeg'],
  description: '可和我們預訂豐富的水上活動，皆有優惠唷！'
};

export default function RoomTypes() {
  const [selectedRoom, setSelectedRoom] = useState<Room | null>(null);

  return (
    <section id="rooms" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">房型介紹</h2>
          <p className="text-xl text-gray-600">多樣化的房型選擇，滿足您的不同需求</p>
        </div>

        {/* Package Deal */}
        <div className="mb-16 bg-gradient-to-r from-orange-50 to-amber-50 rounded-2xl p-8 border-2 border-orange-200">
          <div className="flex items-center gap-3 mb-6">
            <span className="px-4 py-2 bg-orange-500 text-white text-sm font-bold rounded-full whitespace-nowrap">包棟優惠</span>
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900">{packageDeal.name}</h3>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8">
            <div className="relative h-80 rounded-xl overflow-hidden group cursor-pointer">
              <img 
                src={packageDeal.images[0]} 
                alt={packageDeal.name}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
            </div>
            
            <div className="flex flex-col justify-between">
              <div>
                <p className="text-lg text-gray-700 mb-4">{packageDeal.subtitle}</p>
                <div className="grid grid-cols-2 gap-4 mb-6">
                  <div>
                    <p className="text-sm text-gray-600 mb-1">人數限制</p>
                    <p className="text-lg font-semibold text-gray-900">{packageDeal.capacity} 人</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-600 mb-1">坪數</p>
                    <p className="text-lg font-semibold text-gray-900">{packageDeal.size}</p>
                  </div>
                </div>
                <div className="mb-6">
                  <p className="text-sm text-gray-600 mb-2">設施</p>
                  <div className="flex flex-wrap gap-2">
                    {packageDeal.features.map((feature, idx) => (
                      <span key={idx} className="px-3 py-1 bg-white text-gray-700 text-sm rounded-full border border-gray-200">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
              
              <div className="flex items-center justify-between pt-6 border-t border-orange-200">
                <div>
                  <p className="text-sm text-gray-600">每晚</p>
                  <p className="text-3xl font-bold text-orange-600">TWD {packageDeal.price.toLocaleString()}</p>
                </div>
                <a
                  href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即包棟
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Regular Rooms */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {rooms.map((room) => (
            <div 
              key={room.id} 
              className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer"
              onClick={() => setSelectedRoom(room)}
            >
              <div className="relative h-64 overflow-hidden group">
                <img 
                  src={room.images[0]} 
                  alt={room.name}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute top-4 right-4 bg-white px-4 py-2 rounded-full shadow-lg">
                  <p className="text-sm text-gray-600">TWD</p>
                  <p className="text-2xl font-bold text-teal-600">{room.price}</p>
                  <p className="text-xs text-gray-500">起/晚</p>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{room.name}</h3>
                <p className="text-sm text-gray-600 mb-4">{room.subtitle}</p>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-hotel-bed-line text-teal-500 text-lg mr-2 w-6 h-6 flex items-center justify-center"></i>
                    <span>{room.beds.join(', ')}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-group-line text-teal-500 text-lg mr-2 w-6 h-6 flex items-center justify-center"></i>
                    <span>{room.capacity} 人</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <i className="ri-ruler-line text-teal-500 text-lg mr-2 w-6 h-6 flex items-center justify-center"></i>
                    <span>{room.size}</span>
                  </div>
                </div>
                
                <div className="flex flex-wrap gap-2 mb-6">
                  {room.features.slice(0, 3).map((feature, idx) => (
                    <span key={idx} className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">
                      {feature}
                    </span>
                  ))}
                  {room.features.length > 3 && (
                    <span className="px-3 py-1 bg-gray-100 text-gray-700 text-xs rounded-full">
                      +{room.features.length - 3}
                    </span>
                  )}
                </div>
                
                <a
                  href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full py-3 bg-teal-500 hover:bg-teal-600 text-white text-center font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  查看詳情
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Room Detail Modal */}
      {selectedRoom && (
        <div 
          className="fixed inset-0 bg-black/70 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedRoom(null)}
        >
          <div 
            className="bg-white rounded-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="relative h-96">
              <img 
                src={selectedRoom.images[0]} 
                alt={selectedRoom.name}
                className="w-full h-full object-cover"
              />
              <button
                onClick={() => setSelectedRoom(null)}
                className="absolute top-4 right-4 w-10 h-10 bg-white rounded-full flex items-center justify-center hover:bg-gray-100 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl text-gray-900"></i>
              </button>
            </div>
            
            <div className="p-8">
              <h3 className="text-3xl font-bold text-gray-900 mb-2">{selectedRoom.name}</h3>
              <p className="text-lg text-gray-600 mb-6">{selectedRoom.subtitle}</p>
              
              <div className="grid md:grid-cols-3 gap-6 mb-8">
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600 mb-2">床型</p>
                  {selectedRoom.beds.map((bed, idx) => (
                    <p key={idx} className="text-base font-semibold text-gray-900">{bed}</p>
                  ))}
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600 mb-2">人數限制</p>
                  <p className="text-base font-semibold text-gray-900">{selectedRoom.capacity} 人</p>
                </div>
                <div className="p-4 bg-gray-50 rounded-lg">
                  <p className="text-sm text-gray-600 mb-2">坪數</p>
                  <p className="text-base font-semibold text-gray-900">{selectedRoom.size}</p>
                </div>
              </div>
              
              <div className="mb-8">
                <p className="text-sm text-gray-600 mb-3">房間設施</p>
                <div className="flex flex-wrap gap-2">
                  {selectedRoom.features.map((feature, idx) => (
                    <span key={idx} className="px-4 py-2 bg-teal-50 text-teal-700 text-sm rounded-full border border-teal-200">
                      {feature}
                    </span>
                  ))}
                </div>
              </div>
              
              <p className="text-gray-700 mb-8">{selectedRoom.description}</p>
              
              <div className="flex items-center justify-between pt-6 border-t border-gray-200">
                <div>
                  <p className="text-sm text-gray-600">每晚</p>
                  <p className="text-4xl font-bold text-teal-600">TWD {selectedRoom.price.toLocaleString()}</p>
                </div>
                <a
                  href="https://www.booking-owlnest.com/5minbnb?lang=zh_TW&adult=1&child=0&infant=0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="px-8 py-4 bg-teal-500 hover:bg-teal-600 text-white font-semibold rounded-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
                >
                  立即預訂
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
